import React, { useState, useEffect } from "react"
import styled, { keyframes } from "styled-components"
import media from "styled-media-query"

const SliderAnime = keyframes`
  from{
    margin-left: -120%;
  }
  to{
    margin-left: 0;
  }
`
const SliderEnd = keyframes`
  from{
    margin-left: 0;
  }
  to{
    margin-left: 100%;
  }
`
const ContentsIn = keyframes`
  0%{
    opacity: 0;
    transform: translateX(-5vw);
  }
  50%{
    transform: translateX(0);
  }
  100%{
    opacity: 1;
    transform: translateX(0);
  }
`
const Wrap = styled.div<{ isAnime: boolean }>`
  position: ${props => (props.isAnime ? "relative" : "static")};
  overflow: ${props => (props.isAnime ? "hidden" : "visible")};
  height: ${props => (props.isAnime ? "100vh" : "auto")};
  width: ${props => (props.isAnime ? "100vw" : "auto")};
`
const SlideWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 0;
  border-top: solid 100vh #f4f7fb;
  border-right: solid 20vw transparent;
  animation: ${SliderAnime} 0.5s ease 0s 1 forwards,
    ${SliderEnd} 0.5s ease 1s 1 forwards;
  margin-left: -120%;
  z-index: 1;
  will-change: margin-left;
`
const ChildWrap = styled.main<{ isAnime?: boolean }>`
  opacity: 0;
  margin: 10px 16px 0 16px;
  min-width: 288px;
  animation: ${ContentsIn} 2s ease 0.5s 1 forwards;
  will-change: transform;
  ${media.greaterThan("small")`
    width: 976px;
    margin: 10px auto 0 auto;
  `}
`

const Layout = props => {
  const [isAnime, setAnime] = useState(true)
  useEffect(() => {
    scrollTo(0, 0)
  }, [])

  return (
    <Wrap isAnime={isAnime}>
      {isAnime && <SlideWrap />}
      <ChildWrap onAnimationEnd={() => setAnime(false)}>
        {props.children}
      </ChildWrap>
    </Wrap>
  )
}
export default Layout
